import axios from "axios";
import TYPES from "@/constant/types";
import store from "@/store";
import { Dialog, Notify, Toast } from "vant";
import {
  getTokenState,
  clearCrmAuthStorage,
  getCrmLoginPath,
  isTokenInvalidMessage
} from "@/utils/auth";
const baseURL = "";

const instance = axios.create({
  baseURL,
  timeout: 300000,
  headers: {
    "Content-Type": "application/json"
  }
});

let unauthorizedHandling = false;
let unauthorizedNoticeShown = false;

function isAuthRequest(url) {
  return /\/crm-system\/sys\/(login|phoneLogin|sms)/.test(url || "");
}

function handleUnauthorized(payload, url) {
  if (isAuthRequest(url)) return;
  const isCrmRequest = url
    ? /(^|\/)crm-/.test(url)
    : location.pathname.indexOf("/crm/") > -1;
  if (!isCrmRequest) return;

  const message = (payload && (payload.message || (payload.data && payload.data.message))) || "";
  const token = localStorage.getItem(TYPES.STAFF_TOKEN);
  const tokenState = getTokenState(token);
  const tokenInvalid = tokenState === "missing" || tokenState === "expired" || isTokenInvalidMessage(message);

  if (tokenInvalid) {
    if (unauthorizedHandling) return;
    unauthorizedHandling = true;
    clearCrmAuthStorage();
    store.commit("CLEAR_AUTH");
    Dialog.alert({
      title: "提示",
      message: tokenState === "expired"
        ? "您的登录状态已过期，请重新登录。"
        : (message || "登录状态已失效，请重新登录。"),
      confirmButtonText: "重新登录"
    })
      .then(() => window.location.replace(getCrmLoginPath()))
      .catch(() => window.location.replace(getCrmLoginPath()));
    return;
  }

  if (unauthorizedNoticeShown) return;
  unauthorizedNoticeShown = true;
  Toast.clear();
  Notify({
    type: "danger",
    message: message || "登录状态校验异常，请稍后重试。",
    duration: 3000
  });
  setTimeout(() => {
    unauthorizedNoticeShown = false;
  }, 3000);
}

const errorCode = (code,msg) => {

  const codeMessage = {
    200: "服务器成功返回请求的数据。",
    201: "新建或修改数据成功。",
    202: "一个请求已经进入后台排队（异步任务）。",
    204: "删除数据成功。",
    400: "发出的请求有错误，服务器没有进行新建或修改数据的操作。",
    401: "用户没有权限（令牌、用户名、密码错误）。",
    403: "用户得到授权，但是访问是被禁止的。",
    404: "发出的请求针对的是不存在的记录，服务器没有进行操作。",
    406: "请求的格式不可得。",
    410: "请求的资源被永久删除，且不会再得到的。",
    422: "当创建一个对象时，发生一个验证错误。",
    500: "服务器发生错误，请检查服务器。",
    502: "网关错误。",
    503: "服务不可用，服务器暂时过载或维护。",
    504: "网关超时。"
  };
  if (msg || codeMessage[code]) {
    Notify({ type: 'danger', message: msg || codeMessage[code] });
  }
};

instance.interceptors.request.use(
  function (config) {
    const CRMTOKEN = location.pathname.indexOf('/crm/') > -1
    const _token = CRMTOKEN ? localStorage.getItem(TYPES.STAFF_TOKEN) : localStorage.getItem(TYPES.TOKEN_KEY);
    const _token_health = store.getters.userInfo ? (store.getters.userInfo.token || localStorage.getItem(TYPES.TOKEN_KEY_HEALTH)) : localStorage.getItem(TYPES.TOKEN_KEY_HEALTH);
    if (_token) {
      config.headers["X-Access-Token"] = _token;
    }
    if (config.url.includes('jeecg-healthhome')) {
      config.headers["healthhome-token"] = _token;
    }
    if (_token_health) {
      config.headers["healthhome-token"] = _token_health || '';
    }
    return config;
  },
  error => {
    Promise.reject(error)
  }
);

instance.interceptors.response.use(function (resp) {
  const data = resp.data || {};
  if (data.code === 401 || data.code === "401") {
    handleUnauthorized(data, resp.config && resp.config.url);
    return Promise.reject(data);
  }
  if (resp.status != 200 || (data.code != 500 && data.code != 200 && data.code != 0 && data.code != undefined)) {
    // if (resp.status != 200 || (resp.data.code != 200 && resp.data.code != 0 && resp.data.code != undefined)) {
      errorCode(resp.status, data.message);
      return Promise.reject(data);
    }
    return resp.data;
  },
  error => {
    const resp = error.response;
    console.log(resp)
    // errorCode(resp.status);
    if (resp && resp.status === 401) {
      handleUnauthorized(resp, error.config && error.config.url);
    }

    return Promise.reject(error)
  }
);

export default instance;
